import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allVenues:{
        allVenueData: [],
        loading: true,
        error: null,
    },
    myReservations:{
        myReservationData: [],
        venueId: null,
        loading: false,
        error: null,
    },

    isEventModalNeededToOpen : true
};

const tableReservationSlice = createSlice({
    name: 'tableReservation',
    initialState,
    reducers: {
        // All Venues actions
        resetReservationData: () => initialState,
        fetchAllVenuesRequest: (state) => {
            state.allVenues.loading = true;
            state.allVenues.error = null;
        },
        fetchAllVenuesSuccess: (state, action) => {
            state.allVenues.loading = false;
            state.allVenues.allVenueData = action.payload;
        },
        fetchAllVenuesFailure: (state, action) => {
            state.allVenues.loading = false;
            state.allVenues.error = action.payload;
        },

        // My Reservations actions
        fetchMyReservationRequest: (state) => {
            state.myReservations.loading = true;
            state.myReservations.error = null;
        },
        fetchMyReservationSuccess: (state, action) => {
            state.myReservations.loading = false;
            state.myReservations.myReservationData = action.payload?.data?.results;
            state.myReservations.venueId = action.payload?.data?.results?.[0]?.venue_id;
        },
        fetchMyReservationFailure: (state, action) => {
            state.myReservations.loading = false;
            state.myReservations.error = action.payload;
        },
        checkIsEventModalNeededToOpen: (state) => {
            state.isEventModalNeededToOpen = false;
        },
        resetIsEventModalNeededToOpen: (state) => {
            state.isEventModalNeededToOpen = true;
        }

    },
});

// Export the actions
export const {
    resetReservationData,
    fetchAllVenuesRequest,
    fetchAllVenuesSuccess,
    fetchAllVenuesFailure,
    fetchMyReservationRequest,
    fetchMyReservationSuccess,
    fetchMyReservationFailure,
    checkIsEventModalNeededToOpen,
    resetIsEventModalNeededToOpen,
} = tableReservationSlice.actions;

// Export the reducer
export default tableReservationSlice.reducer;